import {useEffect} from "react";

interface GoogleAnalyticsProps {
  code: string;
  isV4: boolean;
}

const GA_ATTR = "data-sp-ga";

export const GoogleAnalytics = ({code, isV4}: GoogleAnalyticsProps) => {
  useEffect(() => {
    if (document.querySelector(`script[${GA_ATTR}="${CSS.escape(code)}"]`)) return;

    const scripts: HTMLScriptElement[] = [];

    if (isV4) {
      const loader = document.createElement("script");
      loader.async = true;
      loader.setAttribute(GA_ATTR, code);
      loader.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(code)}`;
      document.head.appendChild(loader);
      scripts.push(loader);

      const inline = document.createElement("script");
      inline.setAttribute(GA_ATTR, code);
      inline.textContent = [
        "window.dataLayer = window.dataLayer || [];",
        "function gtag(){dataLayer.push(arguments);}",
        "gtag('js', new Date());",
        `gtag('config', ${JSON.stringify(code)});`,
      ].join("\n");
      document.head.appendChild(inline);
      scripts.push(inline);
    } else {
      const script = document.createElement("script");
      script.setAttribute(GA_ATTR, code);
      script.textContent = [
        "(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){",
        "(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),",
        "m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)",
        "})(window,document,'script','https://www.google-analytics.com/analytics.js','ga');",
        `ga('create', ${JSON.stringify(code)}, 'auto');`,
        "ga('send', 'pageview');",
      ].join("\n");
      document.head.appendChild(script);
      scripts.push(script);
    }

    return () => {
      scripts.forEach((el) => el.remove());
    };
  }, [code, isV4]);

  return null;
};
